<template>
  <div class="flex flex-col min-h-screen bg-blue-lighter">
    <Header />
    <main class="grow mb-20">
      <slot></slot>
    </main>
    <NavBarMobile />
  </div>
</template>
